(function () {
  var openTimer = null;

  function isRewardsPanelOpen() {
    var panel = document.querySelector('.stamped-rewards-base');
    if (!panel) return false;
    return window.getComputedStyle(panel).display !== 'none';
  }

  function openRewards() {
    if (!window.StampedFn || typeof window.StampedFn.toggleRewardsModal !== 'function') {
      return false;
    }

    if (!isRewardsPanelOpen()) {
      window.StampedFn.toggleRewardsModal();
    }

    return true;
  }

  function fallbackOpen() {
    var url = new URL(window.location.href);
    url.searchParams.set('rewards-launcher', 'open');
    window.location.assign(url.toString());
  }

  function closeNavDrawer() {
    if (window.theme && theme.NavDrawer && typeof theme.NavDrawer.close === 'function') {
      theme.NavDrawer.close();
      return;
    }

    var closeButton = document.querySelector('#NavDrawer .js-drawer-close');
    if (closeButton) closeButton.click();
  }

  function isHeaderOrDrawerRewardsLink(link) {
    if (!link || !link.getAttribute) return false;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('rewards-circle') === -1) return false;
    return Boolean(link.closest('#SiteHeader, #NavDrawer'));
  }

  function getRewardsTrigger(target) {
    var element = target && target.nodeType === 3 ? target.parentElement : target;
    if (!element || !element.closest) return null;
    return element.closest('[data-rewards-toggle]') ||
      (isHeaderOrDrawerRewardsLink(element.closest('a')) ? element.closest('a') : null);
  }

  function openRewardsWithRetry() {
    if (openRewards()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (openRewards() || tries > 20) {
        window.clearInterval(timer);
        if (tries > 20) fallbackOpen();
      }
    }, 150);
  }

  document.addEventListener('click', function (event) {
    var trigger = getRewardsTrigger(event.target);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var fromDrawer = Boolean(trigger.closest('#NavDrawer'));
    if (fromDrawer) closeNavDrawer();

    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(openRewardsWithRetry, fromDrawer ? 480 : 0);
  }, true);
})();